<div class="row mt-3">
  <div class="col-12">

    <div class="sc__wrapper" *ngIf="!interaction?.completed.onComplete">
      <div id="js--sc--container" class="sc__container">
      </div>
    </div>
    <div *ngIf="interaction?.completed.onComplete">
      <img [src]="content?.imageBackgroundSrc" class="img-fluid"/>
    </div>

  </div>
</div>

